export enum ManageMode {
    Undefined = '',
    New = 'new',
    Edit = 'edit'
  }